export default __webpack_public_path__ + "static/media/rabbit-yellow.ac776db4.png";